// const protocol = window.location.protocol ?? 'https:';
const protocol = 'https:';

const APIBaseURL = protocol+"//ctas.live/backend/api";
const AppBaseURL = protocol+"//yard.ctas.ai";

const OcrImgBaseURL = protocol+"//ctas.live/ocr_backend/uploads/";

const ImgBaseURL = protocol+"//ctas.live/backend/Seal/";

const AccessToken = localStorage.getItem("access_token") ?? null;

export { APIBaseURL, AppBaseURL, AccessToken, OcrImgBaseURL ,ImgBaseURL };
